
<div class="ui checkbox">
  <input type="checkbox" @change="onChange" :id="id" :name="name">
  <label><slot></slot></label>
</div>
